(() => {
  const root = document.querySelector('[data-cookie-consent]');
  if (!root) return;
  const banner = root.querySelector('[data-cookie-banner]');
  const dialog = root.querySelector('[data-cookie-dialog]');
  const categories = ['preferences', 'analytics', 'marketing'];
  const status = text => root.querySelectorAll('[data-cookie-status], [data-cookie-dialog-status]').forEach(el => el.textContent = text);
  let apiPromise;
  let busy = false;
  let opener;
  let sequence = 0;
  const loadApi = () => {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (apiPromise) return apiPromise;
    apiPromise = new Promise((resolve, reject) => {
      let finished = false;
      const timeout = setTimeout(() => finish(new Error('Privacy API timeout')), 10000);
      let retry;
      const finish = error => {
        if (finished) return;
        finished = true;
        clearTimeout(timeout); clearTimeout(retry);
        if (error || !window.Shopify?.customerPrivacy) reject(error || new Error('Privacy API unavailable'));
        else resolve(window.Shopify.customerPrivacy);
      };
      const attempt = () => {
        if (!window.Shopify?.loadFeatures) { retry = setTimeout(attempt, 200); return; }
        try { window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], finish); }
        catch (error) { finish(error); }
      };
      attempt();
    }).catch(error => { apiPromise = undefined; throw error; });
    return apiPromise;
  };
  const close = () => {
    dialog.close();
    if (opener?.isConnected && !opener.closest('[hidden]')) opener.focus({preventScroll: true});
  };
  const setBusy = value => {
    busy = value;
    root.querySelectorAll('button[data-cookie-action]:not([data-cookie-action="close"])').forEach(button => button.disabled = value);
    root.querySelectorAll('[data-cookie-category]').forEach(input => input.disabled = value);
  };
  const showPreferences = async trigger => {
    opener = trigger;
    dialog.showModal(); status(''); setBusy(true);
    categories.forEach(category => root.querySelector(`[data-cookie-category="${category}"]`).checked = false);
    try {
      const api = await loadApi();
      if (!dialog.open) return;
      const consent = api.currentVisitorConsent();
      categories.forEach(category => root.querySelector(`[data-cookie-category="${category}"]`).checked = consent[category] === 'yes');
    } catch { status(root.dataset.error); }
    finally { setBusy(false); }
  };
  const save = async choice => {
    if (busy) return;
    const id = ++sequence;
    setBusy(true); status(root.dataset.saving);
    const values = Object.fromEntries(categories.map(category => [category, choice === 'save' ? root.querySelector(`[data-cookie-category="${category}"]`).checked : choice === 'accept']));
    try {
      const api = await loadApi();
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('Consent save timeout')), 10000);
        try { api.setTrackingConsent(values, result => { clearTimeout(timeout); result?.error ? reject(new Error('Consent save failed')) : resolve(); }); }
        catch (error) { clearTimeout(timeout); reject(error); }
      });
      if (id !== sequence) return;
      banner.hidden = true; status('');
      if (dialog.open) close();
      root.querySelector('[data-cookie-live]').textContent = root.dataset.saved;
    } catch { if (id === sequence) status(root.dataset.error); }
    finally { if (id === sequence) setBusy(false); }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cookie-action], [data-cookie-open]');
    if (!button) return;
    if (button.hasAttribute('data-cookie-open') || button.dataset.cookieAction === 'settings') showPreferences(button);
    else if (button.dataset.cookieAction === 'close') close();
    else if (['accept', 'reject', 'save'].includes(button.dataset.cookieAction)) save(button.dataset.cookieAction);
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  document.addEventListener('visitorConsentCollected', () => {
    if (busy) return;
    try { if (categories.every(category => ['yes', 'no'].includes(window.Shopify.customerPrivacy.currentVisitorConsent()[category]))) banner.hidden = true; }
    catch {}
  });
  loadApi().then(api => {
    const consent = api.currentVisitorConsent();
    banner.hidden = categories.every(category => ['yes', 'no'].includes(consent[category]));
  }).catch(() => { banner.hidden = false; status(root.dataset.error); });
})();
